<template>
  <div>
    <div class="wGC-categoryArea">
      <div class="wGC-head">
        <div class="wGCH-column">
          <h2>分账管理</h2>
        </div>
      </div>
      <div class="wGC-categoryList">
        <div class="wGLG-table">
          <p style="padding: 20px; color: #666;">分账功能开发中...</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BillList',
  data() {
    return {}
  }
}
</script>

<style lang="less" scoped>
</style>
